const config = {
  API_URL: 'https://mini-crm-req1.onrender.com' || 'http://localhost:8000',
  FRONTEND_URL: 'http://localhost:3000',
  GOOGLE_CLIENT_ID: '1027576728634-9bjvnhjqofc970kpoaegbjhf64a1sb3q.apps.googleusercontent.com',
  GOOGLE_CLIENT_SECRET: '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'
};

export default config; 